module.exports = __webpack_public_path__ + "static/media/pills2x.27879591.png";